import { render, staticRenderFns } from "./dataPermissionConfiguration.vue?vue&type=template&id=e8e6099e&scoped=true&"
import script from "./dataPermissionConfiguration.vue?vue&type=script&lang=js&"
export * from "./dataPermissionConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./dataPermissionConfiguration.vue?vue&type=style&index=0&id=e8e6099e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e6099e",
  null
  
)

export default component.exports